//This file is automatically rebuilt by the Cesium build process.
export default "/**\n\
 * The automatic GLSL constant for {@link Pass#GAUSSIAN_SPLATS}\n\
 *\n\
 * @name czm_passGaussianSplats\n\
 * @glslConstant\n\
 *\n\
 * @see czm_pass\n\
 */\n\
const float czm_passGaussianSplats = 12.0;\n\
";
